<template>
    <div v-if="type == 'saidbar'" class="saidbar__loader-skeleton">
        <div class="saibar-wrapper container">
            <div class="top-side">
                <div class="search">
                    <div class="input"></div>
                </div>
                <div class="saidbar-nav">
                    <span class="active"></span>
                    <span></span>
                </div>
                <ul class="menu-list">
                    <li class="menu-list-item active">
                        <span></span>
                    </li>
                    <li class="menu-list-item">
                        <span></span>
                    </li>
                    <li class="menu-list-item">
                        <span></span>
                    </li>
                    <li class="menu-list-item">
                        <span></span>
                    </li>
                    <li class="menu-list-item">
                        <span></span>
                    </li>
                    <li class="menu-list-item">
                        <span></span>
                    </li>
                </ul>
            </div>
            <div class="bottom-side">
                <div class="add">
                    
                </div>
                <div class="profile_load">
                    <div class="account">
                        <span></span>
                    </div>
                    <div class="bell">
                        <span></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="type == 'main'" class="main__loader-skeleton">
        <div class="main-wrapper container">
            <h1></h1>
            <label class="searchbox" for="search">
                <div class="input"></div>
            </label>
            <ul>
                <li>
                    
                </li>
            </ul>
            <div class="list-name">
                <h3></h3>
                <div class="remove">
                    
                </div>
            </div>
            <ul>
                <li>
                    
                </li>
                <li>
                    
                </li>
                <li>
                    
                </li>
                <li>
                    
                </li>
            </ul>
            
            <a class="add-section" href=""></a>
        </div>
    </div>
</template>

<script>

    import { mapGetters } from "vuex"

    export default {
        name: "Loader",
        props: ['type'],
        computed: {
            ...mapGetters(["getAppLoader"])
        }
    }

</script>

<style lang="scss" scoped>

$primary: #07f;
$secondary:#E6E6E6;
$border-color: #d9d9d9;
$dark: #000;
$light: #fff;
$main-background: #DEE8F2;
$secondary-dark: #464646;
$danger: #f12e2e;
$theme-color: rgba(36,37,37,0.631);
$primary-font:var(--theme-font);

*{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.container{
    padding-right: 14px;
    padding-left: 14px;
}

.saidbar__loader-skeleton {
    border-right: 1px solid $border-color;
    min-width: 231px;
    height: 100%;
    background-color: $secondary;
    padding-top: 19px;
    position: relative;
    .saibar-wrapper{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 100%;
    }
    .search{
        display: flex;
        border-radius: 4px;
        margin-bottom: 13px;
        .input{
            height: 25px;
            width: 100%;
            border-radius: 4px;
            background: linear-gradient(-90deg, $border-color, #e9e3e3, $border-color);
            background-size: 200%;
            animation: skeleton 1.3s infinite linear;
            &::placeholder{
                color: #C2CEDF;
                font-size: 12px;
            }
        }
        img{
            position: absolute;
            left: 0;
            margin-left: 7px;
        }
    }
    .saidbar-nav{
        height: 25px;
        display: flex;
        align-items: center;
        margin-bottom: 6px;
        border-radius: 4px;
        overflow: hidden;
        justify-content: space-between;
        span{
            width: 49%;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
            font-family: $primary-font;
            font-size: 12px;
            font-weight: 400;
            color: $primary;
            cursor: pointer;
            border-radius: 4px;
            content: none;
            background: linear-gradient(-90deg, $border-color, #e9e3e3, $border-color);
            background-size: 200%;
            animation: skeleton 1.3s infinite linear;
            &:last-child{
                animation-delay: 0.7s;
                animation-duration: .9s;
            }
        }
    }
    ul{
        list-style: none;
        display: flex;
        flex-direction: column;
        gap: 5px;
        li{
            padding: 6px;
            display: flex;
            align-items: center;
            cursor: pointer;
            border-radius: 4px;
            transition: all 0.3s linear;
            height: 23px;
            background: linear-gradient(-90deg, $border-color, #e9e3e3, $border-color);
            background-size: 200%;
            animation: skeleton 1.3s infinite linear;
        }

    }

    .add {
        margin-bottom: 56px;
        height: 30px;
        width: 100%;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: linear-gradient(-90deg, $border-color, #e9e3e3, $border-color);
            background-size: 200%;
            animation: skeleton 1.3s infinite linear;
    }

    .profile_load{
        display: flex;
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        height: 36px;
        background-color: $light;
        div{
            width: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.3s linear;
            
        }
        .account{
            span{
                background: linear-gradient(-90deg, $border-color, #e9e3e3, $border-color);
                background-size: 200%;
                animation: skeleton 1.3s infinite linear;
                width: 23px;
                height: 23px;
                border-radius: 50%;
                
            }
        }
        .bell{
            span{
                background: linear-gradient(-90deg, $border-color, #e9e3e3, $border-color);
                background-size: 200%;
                animation: skeleton 1.3s infinite linear;
                width: 23px;
                height: 23px;
                border-radius: 20%
            }
        }
    }
}

.main__loader-skeleton {
    width: 100%;
    position: relative;
    height: 100vh;
    .main-wrapper{
        width: 100%;
        height: 100vh;   
        background-color: $main-background;
        padding-top: 14px;
        padding-bottom: 40px;
        overflow-y: scroll;
        &::-webkit-scrollbar {
            display: none;
        }
        h1{
            margin-bottom: 16px;
            width: 120px;
            border-radius: 4px;
            background: linear-gradient(-90deg, $border-color, #e9e3e3, $border-color);
            background-size: 200%;
            animation: skeleton 1.3s infinite linear;
            animation-delay: 0.8s;
            height: 30px;
        }
        .searchbox{
            height: 37px;
            padding: 12px 50px 12px 12px;
            display: flex;
            background: linear-gradient(-90deg, $border-color, #e9e3e3, $border-color);
            background-size: 200%;
            animation: skeleton 1.3s infinite linear;
            animation-delay: 0.8s;
            border-radius: 4px;
        }
        ul{
            padding-top: 14px;
            list-style: none;
            display: flex;
            flex-direction: column;
            gap: 6px;
            li{
                border-radius: 4px;
                background: linear-gradient(-90deg, $border-color, #e9e3e3, $border-color);
                background-size: 200%;
                animation: skeleton 1.3s infinite linear;
                animation-delay: 0.8s;
                display: flex;
                position: relative;
                height: 37px;
                align-items: center;
                padding-left: 12px;
            }
        }

        .list-name{
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: grab;
            h3{
                background: linear-gradient(-90deg, $border-color, #e9e3e3, $border-color);
                background-size: 200%;
                animation: skeleton 1.3s infinite linear;
                animation-delay: 0.8s;
                height: 24px;
                width: 70px;
                border-radius: 4px;
            }
            .remove{
                width: 17px;
                height: 17px;
                border-radius: 50%;
                background: linear-gradient(-90deg, $border-color, #e9e3e3, $border-color);
                background-size: 200%;
                animation: skeleton 1.3s infinite linear;
                animation-delay: 0.8s;
            }
        }
        .add-section{
            padding: 13px 50px;
            margin-bottom: 7px;
            background: linear-gradient(-90deg, $border-color, #e9e3e3, $border-color);
            background-size: 200%;
            animation: skeleton 1.3s infinite linear;
            animation-delay: 0.8s;
            border-radius: 3px;
            display: inline-block;
            margin-top: 22px;
        }

    }
    
}

@keyframes skeleton{
    0%{
        background-position: 100% 0;
    }
    100%{
        background-position: -100% 0;
    }
}

</style>